import { loader } from '../common/helpers/google_maps_loader'

// Some legacy stuff relies on the legacy load behavior
loader.load()
